import React from 'react';

import { Icon, layout } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
  MdInsights,
  MdPeople,
  MdBusiness,
  MdDevices,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';
import Regiondata from 'views/admin/regiondata';
// Auth Imports
import SignInCentered from 'views/auth/signIn';
import Users from 'views/admin/users';
import Analytics from 'views/admin/analytics';
import Dashboard from 'views/admin/dashboard';
import PendingStatus from 'views/admin/PendingStatus';
import { AiOutlineWarning } from 'react-icons/ai';
import { MdPendingActions } from 'react-icons/md';
import BlinkingDot from '../src/components/BlinkingDot/BlinkingDot';
import { MdMap } from 'react-icons/md';
import UserManual from 'views/admin/UserManual/UserManual';
import { BsFileEarmarkPdfFill } from "react-icons/bs";

const allRoutes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <Dashboard />,
     messageNavbar: 'dashboard',
  },

  {
    name: 'Surveys Details',
    layout: '/admin',
    path: '/surveylist',
    icon: <Icon as={MdInsights} width="20px" height="20px" color="inherit" />,
    component: <Analytics />,
    secondary: true,
  },

  {
    name: <BlinkingDot />,
    layout: '/admin',
    path: '/pendinglist',
    icon: <Icon as={MdPendingActions} w="20px" h="20px" color="inherit" />,
    component: <PendingStatus />,
    secondary: true,
  },

  {
    name: 'Users',
    layout: '/admin',
    path: '/users',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    component: <Users />,
    secondary: true,
  },
 {
    name: 'Region Data',
    layout: '/admin',
    path: '/regiondata',
    icon: <Icon as={MdMap} w="20px" h="20px" color="inherit" />,
    component: <Regiondata />,
  },
  {
    name:'User Manual',
    layout:'/admin',
    path:'/usermanual',
    icon: <Icon as={BsFileEarmarkPdfFill} w="20px" h="20px" color="inherit"/>,
    component:<UserManual/>

  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
  },
 
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
];
export default allRoutes;
